import React from "react";

/**
 * DurationInput Component
 * Editable duration input field
 */
const DurationInput = ({ value, onChange, error, placeholder = "00:00:00", className = "edit-time" }) => {
  return (
    <div className="timer-sec-input" style={{ backgroundColor: error && "#fddada" }}>
      <input
        className={className}
        name="time"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type="text"
        autoComplete="off"
      />
    </div>
  );
};

export default DurationInput;
